import { ToastContainer } from 'react-toastify/unstyled';

import { useTheme } from './theme-provider';

export const ThemedToaster = () => {
  const { theme } = useTheme();

  return (
    <div data-testid="themed-toaster">
      <ToastContainer position="bottom-right" autoClose={5000} theme={theme} />
    </div>
  );
};
